import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';

import Box from '@mui/material/Box';

import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';

import AttendancePageHeader from 'modules/attendance/components/AttendancePageHeader';

import useAttendanceTabPage from './useAttendanceTabPage';

const AttendancePage = () => {
  const { tabs, activePage, onGoToTab } = useAttendanceTabPage();

  const { Component, props: componentProps = {} } = activePage || {};

  return (
    <Box>
      <ToMainMenuButton title={<FormattedMessage id="quickLink.attendanceControl" />} />
      <AttendancePageHeader tabs={tabs} activeTab={activePage?.tab} onGoToTab={onGoToTab} />
      <Box mt={2}>{Component && <Component {...componentProps} />}</Box>
      {!activePage && <Redirect to="management" />}
    </Box>
  );
};

export default AttendancePage;
